import React from "react";
import { cleanForRender, CleanHeaders, idFrom, Render, RenderProps } from "../../renderers";
import Markdown from 'markdown-to-jsx';
import parseLinks from "me-at-eon/src/components/ai-assist-refactored/utils/parseLinks";
import { extractNewAiSource, useFeedback } from "@me8eon/feedback";
import { useMessages } from "@me8eon/sessions_messages";
import { getLastObj } from "me-at-eon/src/util/message-utils";
// Apply Render<string> to handle markdown rendering
export const MarkdownRenderer: Render<string> = ({ attribute, rootId, value }: RenderProps<string>) => {
    const id = idFrom(rootId, attribute);
    const cleaned = cleanForRender(value || "");
    const feedbackFn = useFeedback();
    const [messages] = useMessages();

    const onClick = (href: string) => {
        const lastUserMsg = getLastObj(messages || [], "user")?.message?.content as string || "";
        const aiResp = getLastObj(messages, "assistant")?.message?.content as string || "";

        return () => {
            feedbackFn({
                source: "click",
                href,
                index: "0",
                id, query: lastUserMsg,
                sources: messages || [],
                sourceFromAnswer: extractNewAiSource(aiResp)
            });
        };
    };

    return (
        <div id={id}>
            <CleanHeaders>
                <div data-testid={id}>
                    <Markdown
                        options={{
                            overrides: {
                                a: {
                                    component: ({
                                        children,
                                        ...props
                                    }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
                                        <a
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={onClick(props.href || "")}
                                        >
                                            {children}
                                        </a>
                                    ),
                                },
                            },
                        }}
                    >{parseLinks(cleaned)}</Markdown>
                </div>
            </CleanHeaders>
        </div>
    );
};
